import { Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  subHeading1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#000000",
    fontSize: "1rem",
    lineHeight: "1.688rem",
    padding: "0rem 0rem 0rem 0rem",
    margin: "0.5rem 0rem 0rem 0rem",
    background: "#FAFAFA",
    padding: "0.5rem 1rem",
    borderRadius: "1rem",
  },
  subHeading: {
    fontSize: "1rem",
    lineHeight: "1.688rem",
    color: "#212121",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.25rem",
    },
  },
}));

const OthersVicinity = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Detect mobile devices

  const places = [
    { name: "Play Arena", distance: "4.2 KM" },
    { name: "Wipro Technologies", distance: "5.1 KM" },
    { name: "Embassy Tech Village", distance: "5.5 KM" },
    { name: "AMR Tech Park", distance: "5.9 KM" },
  ];

  // Show only the first 4 places on mobile
  const displayedPlaces = isMobile ? places.slice(0, 4) : places;

  return (
    <React.Fragment>
      {displayedPlaces.map((place, index) => (
        <div
          className={classes.subHeading1}
          key={index}
        >
          <Typography className={classes.subHeading}>{place.name}</Typography>
          <Typography className={classes.subHeading}>{place.distance}</Typography>
        </div>
      ))}
    </React.Fragment>
  );
};

export default OthersVicinity;
